// RoundBlockoutsDialog.tsx — Up to 6 round blockouts (rbvar)

import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { usePendingSlot } from './usePendingSlot';
import { useShallowStore } from '../store/useStore';

const FIELDS = [
  { key: 'mark',     label: 'Mark',     type: 'text'   as const },
  { key: 'diameter', label: 'Diameter', type: 'number' as const, unit: '"', min: 0 },
  { key: 'x',        label: 'X Ctr',    type: 'number' as const, unit: '"', min: 0 },
  { key: 'y',        label: 'Y Ctr',    type: 'number' as const, unit: '"', min: 0 },
];

export default function RoundBlockoutsDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = usePendingSlot('rbvar', panel?.rbvar ?? [],
    (px, py, mark) => ({ mark, x: px, y: py }),
    { mark: '', x: 0, y: 0, diameter: 6, depth: 0 });
  if (!panel) return null;

  return (
    <DialogBase title="Round Blockouts (6 max)" onOk={() => updatePanel(panel.id, { rbvar: slots })}>
      <SlotEditor
        slots={slots}
        fields={FIELDS}
        maxSlots={6}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', x: 0, y: 0, diameter: 6, depth: 0 })}
        label="RB"
      />
    </DialogBase>
  );
}
